export default __webpack_public_path__ + "static/media/solteirotriplo_3.107712dc.jpg";